module.exports = __webpack_public_path__ + "img/arrow___down.038f1511.svg";